import React, { useState, useEffect } from "react"
import { withTheme } from "emotion-theming"

import Arrow from "@svgs/arrow"

import { ToTopButton } from "./styles"

const ToTop = ({ theme, step, delay }) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (typeof window !== `undefined`) {
      window.addEventListener("scroll", visibility)
    }

    return () => {
      if (typeof window !== `undefined`) {
        window.removeEventListener("scroll", visibility)
      }
    }
  }, [])

  const visibility = () => {
    if (typeof window !== `undefined`) {
      if (window.pageYOffset === 0) {
        setVisible(false)
      } else {
        setVisible(true)
      }
    }
  }

  const scroll = () => {
    if (typeof window !== `undefined`) {
      try {
        // trying to use new API - https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollTo
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        })
      } catch (error) {
        // just a fallback for older browsers
        window.scrollTo(0, 0)
      }
    }
  }

  return (
    <ToTopButton visible={visible} onClick={() => scroll()}>
      <Arrow
        style={{
          display: "inline-block",
          marginRight: "0.5rem",
          height: "0.8rem",
        }}
        colour={theme.backgroundColor}
      />{" "}
      To Top
    </ToTopButton>
  )
}

export default withTheme(ToTop)
